import { Component, inject, input, output, ResourceRef } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { Product } from '../../models/product';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AccountStore } from '../../store/account-store';
import { MatBadgeModule } from '@angular/material/badge';

@Component({
    selector: 'app-list-of-products',
    imports: [
        MatCardModule,
        NgScrollbarModule,
        NgxSkeletonLoaderModule,
        MatBadgeModule,
    ],
    templateUrl: './list-of-products.component.html',
    styleUrl: './list-of-products.component.scss',
})
export class ListOfProductsComponent {
    productListInput = input<Product[]>();
    public store = inject(AccountStore);

    public loader = Array(2);

    productResourceRef = input<
        ResourceRef<
            | {
                  status: number;
                  message: string;
                  data: Product[];
              }
            | undefined
        >
    >();

    public productEmitter = output<Product>();

    constructor(public readonly themeService: CustomizerSettingsService) {}

    public selectProduct(product: Product): void {
        this.productEmitter.emit(product);
    }

    getTheme() {
        return {
            'border-radius': '5px',
            height: '157px',
            width: '100%',
            'background-color': 'rgba(117, 127, 239, 0.1)',
        };
    }
}
